import React from 'react';
import { Stack } from 'react-bootstrap';
import { HiInformationCircle } from 'react-icons/hi2';

import { developerUrls } from '../config/external-urls';
import ContentCard from './ContentCard';
import ExternalLink from './ExternalLink';

const CredentialInformationYahoo = () => {
  return (
    <>
      <div className="mt-5 mb-4">
        <h2 className="mb-0">Before You Start</h2>
      </div>
      <ContentCard className="fs-7">
        <Stack gap={3}>
          <Stack direction="horizontal" gap={3} className="align-items-start">
            <span className="flex-shrink-0 text-success">
              <HiInformationCircle size={32} />
            </span>
            <div>
              <strong>Make sure you are Yahoo verified developer.</strong>
              <br />
              Before you can create your Yahoo OAuth client, you’ll need to be verified as
              a developer. Visit the Yahoo Sender Hub and{' '}
              <ExternalLink href={developerUrls.yahooForm}>
                complete this form
              </ExternalLink>{' '}
              and complete all the fields, being sure to select <code>CardDav</code> as
              the API Required.
              <br />
              <br />
              Once you submit, you should immediately receive an email to confirm that
              they received your request.
              <br />
              <br />
              At this time there is no indication of how long the request will take to
              process.
            </div>
          </Stack>
        </Stack>
      </ContentCard>

      <div className="mt-5 mb-4">
        <h2 className="mb-0">Get Your Yahoo OAuth</h2>
      </div>
      <ContentCard className="fs-7">
        <Stack gap={3}>
          <Stack direction="horizontal" gap={3} className="align-items-start">
            <span className="icon-number" data-number="1" />
            <div>
              <strong>Make sure your website is publicly accessible.</strong>
              <br />
              This is required in order to complete successfully the next steps.
            </div>
          </Stack>

          <Stack direction="horizontal" gap={3} className="align-items-start">
            <span className="icon-number" data-number="2" />
            <div>
              <strong>Make sure you’ve installed our proxy script</strong>
              <br />
              It needs to be installed on your live website in a publicly accessible
              place. Once you’ve installed it, write down the URL, you’ll need it later.{' '}
              <ExternalLink href={developerUrls.learnAboutProxyUrl}>
                Find out more about the Proxy URL installation.
              </ExternalLink>
            </div>
          </Stack>

          <Stack direction="horizontal" gap={3} className="align-items-start">
            <span className="icon-number" data-number="3" />
            <div>
              <strong>Sign in to the Yahoo Developer Portal.</strong>
              <br />
              Go to{' '}
              <ExternalLink href={developerUrls.yahooPortal}>
                Yahoo Developer Portal
              </ExternalLink>{' '}
              and sign in with the Yahoo ID that is associated with your verified
              developer account.
            </div>
          </Stack>

          <Stack direction="horizontal" gap={3} className="align-items-start">
            <span className="icon-number" data-number="4" />
            <div>
              <strong>Follow our detailed instructions.</strong>
              <br />
              After you follow{' '}
              <ExternalLink href={developerUrls.oauth.yahoo}>these steps</ExternalLink> ,
              your users will see your domain in the Yahoo Authentication window instead
              of ours.
            </div>
          </Stack>
        </Stack>
      </ContentCard>
    </>
  );
};

export default CredentialInformationYahoo;
